import ResultsPage from "./ResultsPage";
import RemoveBetSheet from "../components/ui/RemoveBetSheet";
import { useRemoveBetTarget } from "../hooks/useRemoveBetTarget";

// ResultsTab (#1214 PR B, Task 5).
// Single job: host ResultsPage as the top-level HISTORY tab with the page's one Remove sheet.
// Reads: ResultsPage's props plus user, removeBet, haptic. Writes: nothing -- the sheet hands a
// confirmed id to removeBet. Does NOT: add any logic to App.js or fork the sheet (spec §16.3,
// "one sheet per page"; MySlipsPage hosts the same pair for the in-page History toggle).
export default function ResultsTab({ user, removeBet, haptic, ...resultsProps }) {
  const { target, onRequestRemove, closeRemove } = useRemoveBetTarget({ user, removeBet });
  return (
    <>
      <ResultsPage {...resultsProps} onRequestRemove={onRequestRemove} />
      <RemoveBetSheet key={user?.id ?? "guest"} target={target} onClose={closeRemove} onRemoved={removeBet} haptic={haptic} />
    </>
  );
}
